/** Reads one-time company/private preference left in localStorage (legacy flow). */
export function getInitialIsCompany(): boolean {
  const stored = localStorage.getItem("isCompany");

  if (stored === "false") {
    localStorage.removeItem("isCompany");
    return false;
  }

  return true;
}
